import api from "api/api";

export const getMissionLateQuery = async ({ manager_id, type, userScope }) =>
  await api.get(
    `/dashboard/mission/late?manager-id=${manager_id}&type=${type}&scope=${userScope}`
  );
